import { useMaterials, useSelectedValueByVariableKey } from '@k3/core'
import { MeshReflectorMaterial, Plane, Circle } from '@react-three/drei'
import { Keys, MaterialNames } from '../utility/utils'
import { useEffect, useMemo, useState } from 'react'
import { SupportedMaterial } from '@k3/core/src/lib/types/material.interface'
import { loadMaterial } from '../utility/materialLoader'

export function ShinyGround() {
  const [bodenMaterial, setBodenMaterial] = useState<SupportedMaterial>()
  const materialList = useMaterials()
  const materials = useMemo(
    () => new Map(materialList.map((m) => [m.name, m])),
    [materialList]
  )
  useEffect(() => {
    if (materials.has(MaterialNames.Boden)) {
      loadMaterial(materials.get(MaterialNames.Boden)!, setBodenMaterial)
    } else {
      setBodenMaterial(undefined)
    }
  }, [materials])

  const groundColor =
    useSelectedValueByVariableKey(
      Keys.GroundColor.Variable
    )?.value?.toString() ?? Keys.GroundColor.Default

  return (
    <group position={[0, -0.01, 0]}>
      <Plane
        receiveShadow
        args={[4, 4]}
        rotation-x={-Math.PI / 2}
        matrixWorldAutoUpdate={undefined}
        getObjectsByProperty={undefined}
        getVertexPosition={undefined}
      >
        <MeshReflectorMaterial
          mirror={0}
          blur={[300, 300]}
          resolution={1024}
          mixBlur={0.6}
          color={groundColor}
          metalness={0}
          roughness={1}
          forceSinglePass={undefined}
        />
      </Plane>
      {bodenMaterial && (
        <Circle
          receiveShadow
          args={[25, 36]}
          rotation-x={-Math.PI / 2}
          position={[0, -0.001, 0]}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
          material={bodenMaterial}
        />
      )}
      <gridHelper
        args={[4, 4, 'white', 'white']}
        position={[0, 0.001, 0]}
      ></gridHelper>
    </group>
  )
}
